(function () {
  var API_BASE = 'https://servicify-appointments.herokuapp.com/api';

  var WEEKDAY_KEYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var WEEKDAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function toDateKey(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function addDays(d, n) {
    var copy = new Date(d);
    copy.setDate(copy.getDate() + n);
    return copy;
  }

  function formatTime(hhmm, withSuffix) {
    var parts = hhmm.split(':');
    var h = parseInt(parts[0], 10);
    var m = parts[1];
    var suffix = h >= 12 ? 'PM' : 'AM';
    var h12 = h % 12;
    if (h12 === 0) h12 = 12;
    return h12 + (m === '00' ? '' : ':' + m) + (withSuffix === false ? '' : ' ' + suffix);
  }

  function formatRange(rangeStr) {
    var bits = rangeStr.split('-');
    if (bits.length !== 2) return rangeStr;
    var startSuffix = parseInt(bits[0].split(':')[0], 10) >= 12 ? 'PM' : 'AM';
    var endSuffix = parseInt(bits[1].split(':')[0], 10) >= 12 ? 'PM' : 'AM';
    var sameSuffix = startSuffix === endSuffix;
    return formatTime(bits[0], !sameSuffix) + '–' + formatTime(bits[1]);
  }

  function enableDragScroll(el) {
    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = false;

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScrollLeft = el.scrollLeft;
    });

    window.addEventListener('mouseup', function () {
      isDown = false;
      el.classList.remove('is-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4) {
        if (!moved) el.classList.add('is-dragging');
        moved = true;
      }
      if (moved) el.scrollLeft = startScrollLeft - dx;
    });

    el.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function jsonFetch(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (res) {
      // A product with no matching booking event (e.g. a non-class product
      // that's merely filed in the same collection) gets a 204 here rather
      // than an error — that's the signal used to drop it as a candidate.
      if (res.status === 204) return null;
      if (!res.ok) throw new Error('Request failed: ' + url);
      return res.json();
    });
  }

  // Product titles from Shopify aren't tuned for a filter pill's label —
  // trim off trailing location/status parentheticals and a leading brand
  // prefix so "Try Wheel throwing （one time） (Markham)" reads as
  // "Try Wheel throwing （one time）".
  function cleanLabel(title) {
    return (title || '')
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/^OOTB\s+/i, '')
      .trim() || title;
  }

  function initSchedule(root, cfg) {
    var grid = root.querySelector('[data-schedule-grid]');
    var rangeLabel = root.querySelector('[data-range]');
    var filtersContainer = root.querySelector('[data-schedule-filters]');
    var prevBtn = root.querySelector('[data-nav="prev"]');
    var nextBtn = root.querySelector('[data-nav="next"]');
    var shopDomain = cfg.shopDomain || 'ootb.ca';
    var activeFilter = 'all';

    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var weekStart = new Date(today);

    var configCache = {}; // classHandle -> { eventId, regularHours, specialHours, duration, numAttendees, employeeIds, timezone }
    var validClassesPromise = null;

    // Resolves once: checks every candidate product for a real booking
    // event, keeping only the ones that have one. The event's own id
    // (returned by this same call) becomes classDef.eventId — no separate
    // lookup or hardcoded id needed.
    function resolveValidClasses() {
      if (validClassesPromise) return validClassesPromise;
      validClassesPromise = Promise.all(cfg.classDefs.map(function (classDef) {
        var url = API_BASE + '/products/' + classDef.productId + '/events?variantId=' + classDef.variantId;
        return jsonFetch(url).then(function (data) {
          if (!data) return null;
          var employees = data.employees || [];
          var employee = employees[0] || {};
          classDef.eventId = data.id;
          classDef.label = cleanLabel(classDef.title);
          configCache[classDef.handle] = {
            regularHours: employee.regularHours || {},
            specialHours: employee.specialHours || {},
            duration: data.duration,
            numAttendees: data.numAttendees,
            employeeIds: employees.map(function (e) { return e.id; }).filter(function (id) { return id != null; }),
            timezone: employee.timezone || 'America/Toronto'
          };
          return classDef;
        }).catch(function () { return null; });
      })).then(function (results) {
        return results.filter(Boolean);
      });
      return validClassesPromise;
    }

    function buildFilters(validClasses) {
      validClasses.forEach(function (classDef) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ootb-schedule__filter';
        btn.setAttribute('data-filter', classDef.handle);
        btn.textContent = classDef.label;
        filtersContainer.appendChild(btn);
      });

      var filterBtns = filtersContainer.querySelectorAll('.ootb-schedule__filter');
      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          activeFilter = btn.dataset.filter;
          applyFilter();
        });
      });
    }

    function fetchAvailability(classDef, startKey, endKey) {
      var url = API_BASE + '/events/' + classDef.eventId + '/availability?startDate=' + startKey + '&endDate=' + endKey;
      return jsonFetch(url).then(function (data) {
        return data || { disabledDays: [], numOpenSlotsMap: {} };
      }).catch(function () {
        return { disabledDays: [], numOpenSlotsMap: {} };
      });
    }

    // "hh:mm am/pm" (as returned by the busy-slots endpoint) -> "HH:mm",
    // so a booking's start time can be matched against a session's own
    // "HH:mm-HH:mm" range key.
    function parseAmPmTo24(str) {
      var m = /^(\d{1,2}):(\d{2})\s*([ap]m)$/i.exec((str || '').trim());
      if (!m) return null;
      var h = parseInt(m[1], 10);
      var suffix = m[3].toLowerCase();
      if (suffix === 'pm' && h !== 12) h += 12;
      if (suffix === 'am' && h === 12) h = 0;
      return String(h).padStart(2, '0') + ':' + m[2];
    }

    // Per-session capacity (numAttendees) is fixed, but bookings already
    // taken vary per exact date+time — this is the only endpoint that
    // exposes individual bookings, so it's what makes a per-slot (rather
    // than per-day-total) open count possible.
    function fetchBookedPerSlot(classDef, info, startKey, endKey) {
      if (!info.employeeIds.length) return Promise.resolve(null);
      var url = API_BASE + '/events/' + classDef.eventId + '/employees/busy-slots';
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          employeeIds: info.employeeIds,
          dateFrom: startKey,
          dateTo: endKey,
          inputTimezone: info.timezone
        })
      }).then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          var booked = {}; // "YYYY-MM-DD|HH:mm" -> quantity booked
          if (!data || !data.bookings) return booked;
          Object.keys(data.bookings).forEach(function (empId) {
            (data.bookings[empId] || []).forEach(function (b) {
              var d = b.date || {};
              var dateKey = d.startDateString;
              var start24 = parseAmPmTo24(d.startTime);
              if (!dateKey || !start24) return;
              var key = dateKey + '|' + start24;
              booked[key] = (booked[key] || 0) + (b.quantity || 1);
            });
          });
          return booked;
        }).catch(function () { return null; });
    }

    // Returns the open-spot count for one exact session on one date, or
    // undefined if we don't have enough data to know it precisely (caller
    // falls back to the day-level estimate in that case).
    function slotOpenCount(info, booked, dateKey, session) {
      if (typeof info.numAttendees !== 'number' || !booked) return undefined;
      var sessionStart = session.split('-')[0];
      var bookedCount = booked[dateKey + '|' + sessionStart] || 0;
      return Math.max(0, info.numAttendees - bookedCount);
    }

    function render() {
      resolveValidClasses().then(function (validClasses) {
        if (!filtersContainer.dataset.built) {
          filtersContainer.dataset.built = 'true';
          buildFilters(validClasses);
        }

        if (!validClasses.length) {
          grid.innerHTML = '<div class="ootb-schedule__loading">No classes are open for booking right now — check back soon.</div>';
          return;
        }

        var days = [];
        for (var i = 0; i < 7; i++) days.push(addDays(weekStart, i));

        var startKey = toDateKey(days[0]);
        var endKey = toDateKey(days[6]);
        rangeLabel.textContent =
          MONTH_SHORT[days[0].getMonth()] + ' ' + days[0].getDate() + ' – ' +
          MONTH_SHORT[days[6].getMonth()] + ' ' + days[6].getDate();

        grid.innerHTML = '<div class="ootb-schedule__loading"><span class="ootb-schedule__spinner" aria-hidden="true"></span>Loading this week’s studio schedule…</div>';

        var work = validClasses.map(function (classDef) {
          var info = configCache[classDef.handle];
          return Promise.all([
            fetchAvailability(classDef, startKey, endKey),
            fetchBookedPerSlot(classDef, info, startKey, endKey)
          ]).then(function (res) {
            return { classDef: classDef, info: info, avail: res[0], booked: res[1] };
          });
        });

        Promise.all(work).then(function (results) {
          grid.innerHTML = '';
          days.forEach(function (day) {
            grid.appendChild(renderDayColumn(day, results));
          });
          applyFilter();
        }).catch(function () {
          grid.innerHTML = '<div class="ootb-schedule__loading">Couldn’t load the schedule right now — please try again shortly.</div>';
        });
      }).catch(function () {
        grid.innerHTML = '<div class="ootb-schedule__loading">Couldn’t load the schedule right now — please try again shortly.</div>';
      });
    }

    function renderDayColumn(day, results) {
      var dateKey = toDateKey(day);
      var weekdayKey = WEEKDAY_KEYS[day.getDay()];
      var col = document.createElement('div');
      col.className = 'ootb-schedule__day' + (dateKey === toDateKey(today) ? ' is-today' : '');

      var head = document.createElement('div');
      head.className = 'ootb-schedule__day-head';
      head.innerHTML =
        '<span class="ootb-schedule__day-name">' + WEEKDAY_SHORT[day.getDay()] + '</span>' +
        '<span class="ootb-schedule__day-num">' + day.getDate() + '</span>';
      col.appendChild(head);

      var cardsWrap = document.createElement('div');
      cardsWrap.className = 'ootb-schedule__day-cards';

      var cardCount = 0;

      results.forEach(function (result) {
        var classDef = result.classDef;
        var info = result.info;
        var avail = result.avail;
        var booked = result.booked;

        if ((avail.disabledDays || []).some(function (iso) { return iso.slice(0, 10) === dateKey; })) {
          return;
        }

        var sessions = info.specialHours && info.specialHours.hasOwnProperty(dateKey)
          ? info.specialHours[dateKey]
          : (info.regularHours[weekdayKey] || []);

        sessions = (sessions || []).filter(function (s) { return s && s.indexOf('-') > -1; });
        if (!sessions.length) return;

        // Per-session open count when we have exact booking data; otherwise
        // fall back to the day-level estimate (flagged with "~" since it's
        // a day total, not this exact session's count).
        var dayLevelEstimate = avail.numOpenSlotsMap ? avail.numOpenSlotsMap[dateKey] : undefined;
        var sessionSpots = sessions.map(function (session) {
          var exact = slotOpenCount(info, booked, dateKey, session);
          if (exact !== undefined) return { spots: exact, isExact: true };
          return { spots: dayLevelEstimate, isExact: false };
        });

        cardCount++;
        cardsWrap.appendChild(renderGroupedCard(classDef, sessions, sessionSpots, shopDomain));
      });

      if (!cardCount) {
        var empty = document.createElement('div');
        empty.className = 'ootb-schedule__empty';
        empty.textContent = 'No sessions';
        cardsWrap.appendChild(empty);
      }

      col.appendChild(cardsWrap);
      return col;
    }

    function renderGroupedCard(classDef, sessions, sessionSpots, shopDomain) {
      var card = document.createElement('div');
      card.className = 'ootb-card';
      card.dataset.classKey = classDef.handle;

      var bookHref = 'https://' + shopDomain + '/products/' + classDef.handle;

      var pillsHtml = sessions.map(function (session, i) {
        var entry = sessionSpots[i];
        var openSlots = entry.spots;
        var spotsClass, spotsText;
        if (openSlots === undefined || openSlots === null) {
          spotsText = 'Check';
          spotsClass = 'is-open';
        } else if (openSlots <= 0) {
          spotsText = 'Full';
          spotsClass = 'is-full';
        } else if (openSlots <= 2) {
          spotsText = openSlots + ' left';
          spotsClass = 'is-low';
        } else {
          spotsText = (entry.isExact ? '' : '~') + openSlots + ' open';
          spotsClass = 'is-open';
        }
        // Same-tab navigation (no target="_blank"/window.open) so the
        // browser's normal back button returns to this schedule — some
        // embedded browsers (e.g. WhatsApp's in-app browser) don't keep
        // usable back-history across a window.open/_blank navigation.
        return '<a class="ootb-card__time-pill ' + spotsClass + '" href="' + bookHref + '">' +
          formatRange(session) + '<b>' + spotsText + '</b>' +
          '</a>';
      }).join('');

      card.innerHTML =
        '<div class="ootb-card__media">' +
          '<img src="' + classDef.image + '" alt="' + escapeHtml(classDef.title) + '" loading="lazy">' +
          '<span class="ootb-card__category">' + escapeHtml(classDef.label) + '</span>' +
        '</div>' +
        '<div class="ootb-card__body">' +
          '<p class="ootb-card__title">' + escapeHtml(classDef.title) + '</p>' +
          '<div class="ootb-card__times">' + pillsHtml + '</div>' +
        '</div>';

      card.addEventListener('click', function (e) {
        if (e.target.closest('.ootb-card__time-pill')) return;
        window.location.href = bookHref;
      });

      return card;
    }

    function applyFilter() {
      var cards = grid.querySelectorAll('.ootb-card');
      cards.forEach(function (card) {
        var match = activeFilter === 'all' || card.dataset.classKey === activeFilter;
        card.classList.toggle('is-hidden', !match);
      });
    }

    prevBtn.addEventListener('click', function () {
      weekStart = addDays(weekStart, -7);
      render();
    });

    nextBtn.addEventListener('click', function () {
      weekStart = addDays(weekStart, 7);
      render();
    });

    enableDragScroll(grid);
    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    (window.ootbScheduleConfig || []).forEach(function (cfg) {
      var root = document.getElementById('ootb-schedule-' + cfg.sectionId);
      if (root) initSchedule(root, cfg);
    });
  });
})();
